<div class="w-full mx-auto">
  <div class="flex flex-row">
    <aside class="sidebar xl:block hidden basis-1/4 h-screen">
      <div id="particles" class="p-12">
        <div class="relative w-full h-full">
          <div class="text-white">
            <h1>
              <a class="logo-link" routerLink="/">
                <img class="w-full" src="assets/logos/app-logo-white.svg" alt="Media Lounge" />
                <span class="claim" i18n>Explore selected images and videos</span>
              </a>
            </h1>
          </div>
        </div>
      </div>
    </aside>
    <main class="w-full xl:basis-3/4 h-screen">
      <div class="w-full h-full">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
<div class="version">{{ version }}</div>
